var e = { editor: {
	editTitle: "Edit Pricing Rule",
	newTitle: "New Pricing Rule",
	guide: "Guide",
	back: "Back",
	startBuilding: "Start building",
	cancel: "Cancel",
	updateRule: "Update Rule",
	saveRule: "Save Rule",
	titleField: "Title",
	titlePlaceholder: "Rule title",
	descriptionField: "Description",
	descriptionPlaceholder: "Description (optional)",
	titleRequired: "Rule title is required"
} };
//#endregion
export { e as default };
